const baseUrl = '/utilityproviders';
const baseUrlUtility = '/utility';
export const utilityProvidersRoutes = {
  baseUrl: "".concat(baseUrl),
  providersList: "".concat(baseUrl, "/list"),
  baseUrlV2: "".concat(baseUrl, "/v2"),
  baseUrlUtility: "".concat(baseUrlUtility),
  getUtilityInfo: "".concat(baseUrlUtility, "/getutilityinfo"),
  providerId: id => "".concat(baseUrl, "/").concat(id),
  utility: 'utility',
  utilityToProvider: providerId => "".concat(baseUrlUtility, "/").concat(providerId)
};